import React, { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import useRoutes from '../_hook/useRoutes';
import Context from '../../context';

const useStyles = makeStyles((theme) => ({
  freeSubscriptionWarning: {
    color: '#DDDDDD',
    padding: theme.spacing(1),
    textDecoration: 'none',
    float: 'right',
  },
}));

interface IProps {
  style?: React.CSSProperties;
}

export default function FreePackagePlanSubscriptionPaper(props: IProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { path } = useRoutes();
  const { style } = props;
  const { company } = useContext(Context);

  return (
    <Paper
      variant="outlined"
      sx={{
        backgroundColor: '	#777777',
        maxWidth: '50%',
      }}
      style={style}
    >
      <Typography
        variant="h5"
        align="center"
        className={classes.freeSubscriptionWarning}
        component={Link}
        to={path('plan.subscriptions', {
          companyID: company._id,
        })}
      >
        {t(
          'you_are_subscribed_to_free_package_please_upgrade_your_subscription_to_enjoy_more_benefit'
        )}
      </Typography>
    </Paper>
  );
}
